module.exports = __webpack_public_path__ + "img/closed.a90c96b2.svg";